import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from '@blueprintjs/core'
import css from './spaceCatalog.module.scss'
import SelectedSpaceTab from '../SelectedSpaceTab'
import SpaceCatalogHeader from './SpaceCatalogHeader'
import { ICurrentUser, IEmployeeDetails, IFloorDetails, IUsageType } from '@api'
import { AboutTab } from '../components/AboutTab'
import { AssignedTab } from '../components/AssignedTab'
import useSpaceDetails from '../hooks/useSpaceDetails'
import { get } from 'lodash'
import { useFloor } from '@providers/mapProvider'
import { isHot, isHoteling, isReserved } from '@utils'
import { getPermissions, parseInputObject } from '..'
enum AllTabs {
  ABOUT = 'about',
  ASSIGNED = 'assigned',
  UPLOAD = 'upload',
}

type SpaceCatalogProps = {
  updateDefaultImage: boolean
  setUpdateDefaultImage: (value: boolean) => void
  splitScreen: boolean
  setSplitScreen: (value: boolean) => void
  floorDetails: IFloorDetails
  isSpaceSelected: string | boolean
  user: ICurrentUser
}
const SpaceCatalog = ({
  updateDefaultImage,
  setUpdateDefaultImage,
  splitScreen,
  setSplitScreen,
  floorDetails,
  isSpaceSelected,
  user,
}: SpaceCatalogProps) => {
  const [selectedTab, setSelectedTab] = useState<AllTabs>(AllTabs.ABOUT)
  const floor = useFloor()
  const selectedSpaceId = get(floor, 'selection.selectedSpacesList[0]', '')
  const {
    data: { space },
  } = useSpaceDetails(selectedSpaceId)
  const { dept, team }: any = !!space && parseInputObject(space)
  const userObject = get(user, 'user.employee') as unknown as IEmployeeDetails
  const { canChangeCalendar }: any =
    !!space && getPermissions(dept, team, floor.floorId as string, userObject, floorDetails)
  const test = Array(100).fill('Test')
  useEffect(() => setSelectedTab(AllTabs.ABOUT), [splitScreen, isSpaceSelected])
  return (
    <>
      <div>
        <SpaceCatalogHeader
          setSplitScreen={setSplitScreen}
          floorDetails={floorDetails}
          updateDefaultImage={updateDefaultImage}
        />
      </div>
      <Tabs
        className={css.tabs}
        selectedTabId={selectedTab}
        onChange={(tab: AllTabs) => setSelectedTab(tab)}>
        <Tab
          id="about"
          title="About"
          style={selectedTab === AllTabs.ABOUT ? { color: 'var(--primary-color)' } : undefined}
          panel={
            <div>
              <AboutTab canChangeCalendar={canChangeCalendar} setSplitScreen={setSplitScreen} />
            </div>
          }
          className={css.tab}></Tab>
        {!isHoteling(space?.usageType as IUsageType) &&
          !isHot(space?.usageType as IUsageType) &&
          !isReserved(space?.usageType as IUsageType) && (
            <Tab
              id="assigned"
              title="Assigned"
              style={
                selectedTab === AllTabs.ASSIGNED ? { color: 'var(--primary-color)' } : undefined
              }
              panel={
                <div>
                  <AssignedTab />
                </div>
              }
              className={css.tab}></Tab>
          )}
        <Tab
          id="upload"
          title="Upload"
          style={selectedTab === AllTabs.UPLOAD ? { color: 'var(--primary-color)' } : undefined}
          className={css.tab}
          panel={
            <SelectedSpaceTab
              updateDefaultImage={updateDefaultImage}
              setUpdateDefaultImage={setUpdateDefaultImage}
            />
          }></Tab>
      </Tabs>
    </>
  )
}
export default SpaceCatalog
